import { useState } from "react";
import { Plus, X } from "lucide-react";

interface FacetFormMultiInputProps {
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
}

export default function FacetFormMultiInput({ values, onChange, placeholder }: FacetFormMultiInputProps) {
  const [draft, setDraft] = useState("");

  const addValue = () => {
    const trimmed = draft.trim();
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed]);
      setDraft("");
    }
  };

  const removeValue = (index: number) => {
    onChange(values.filter((_, i) => i !== index));
  };

  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5 rounded-lg border border-slate-200 bg-white p-2 shadow-sm transition focus-within:border-indigo-400 focus-within:ring-2 focus-within:ring-indigo-400/20">
      {values.map((v, i) => (
        <span
          key={`${v}-${i}`}
          className="inline-flex items-center gap-1 rounded-md bg-indigo-50 px-2 py-1 text-[11px] font-medium text-indigo-700 ring-1 ring-indigo-100"
        >
          {v}
          <button
            type="button"
            onClick={() => removeValue(i)}
            className="rounded-sm text-indigo-400 transition hover:bg-indigo-100 hover:text-indigo-600"
          >
            <X size={12} />
          </button>
        </span>
      ))}
      <div className="inline-flex min-w-[160px] flex-1 items-center gap-1">
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addValue())}
          placeholder={placeholder ?? "Type and press Enter"}
          className="min-w-0 flex-1 bg-transparent px-1 py-0.5 text-[12px] text-slate-800 outline-none placeholder:text-slate-400"
        />
        {draft.trim() && (
          <button
            type="button"
            onClick={addValue}
            className="shrink-0 rounded-md bg-indigo-50 p-1 text-indigo-500 transition hover:bg-indigo-100"
          >
            <Plus size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
